/**
 * Redirects the browser to the specified URL.
 *
 * This function encapsulates browser redirection to allow for mocking in
 * tests, making it possible to verify redirect behavior without actually
 * navigating away from the page. This is useful because we use jsdom, which
 * does not support window.location.assign.
 *
 * @param url The URL to redirect to
 */
export function redirectTo(url: string) {
    window.location.assign(url);
}
